// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import router from './router'
import vuex from './vuex'
import vueWechatTitle from 'vue-wechat-title'
import store from 'store'
import vueCookie from 'vue-cookie'
import http from './untils/http'
import passport from './untils/passport'
import RongIMClientInit from './untils/im'
import filters from './untils/filters'
import icon from '@/components/Common/icon.vue'
import { KEY } from '@/config'
import { Icon, Cell, CellGroup, Button, Popup, Picker, Notify, SwipeCell, Field, Area, Uploader,TreeSelect, DatetimePicker, NumberKeyboard, Toast, ImagePreview, Loading, CountDown} from 'vant'
import '@/assets/common.less'
import '@/assets/fonts/iconfont.css'
import '@/assets/fonts/iconfont.js'
import vueSwiper from 'vue-awesome-swiper'
import '@/assets/swiper.css'

import 'moment/locale/zh-cn'


Notify.setDefaultOptions({
  background: '#F96B6F',
  duration: 2000
})

window.store = store;

Vue.use(vueWechatTitle)
Vue.use(vueCookie)
Vue.use(Icon)
   .use(Button)
   .use(Popup)
   .use(Notify)
   .use(SwipeCell)
   .use(Field)
   .use(Cell)
   .use(CellGroup)
   .use(Area)
   .use(Picker)
   .use(Uploader)
   .use(TreeSelect)
   .use(DatetimePicker)
   .use(NumberKeyboard)
   .use(Toast)
   .use(ImagePreview)
   .use(Loading)
   .use(CountDown)
   .use(vueSwiper)

Vue.config.productionTip = false

// 注册全局icon组件
Vue.component('icon', icon)

// 自定义指令解决iOS微信浏览器软键盘回收时页面卡住的问题
Vue.directive('ios-bug-fixed', {
  inserted(el) {
    el.__reset_input_handler = () => {
      window.scrollBy(0, -1);
      setTimeout(() => {
        window.scrollBy(0, 1);
      }, 10);
    }
    el.addEventListener('focusout', el.__reset_input_handler);
    el.addEventListener('blur', el.__reset_input_handler);
  },
  unbind(el) {
    el.removeEventListener('focusout', el.__reset_input_handler);
    el.removeEventListener('blur', el.__reset_input_handler);
    delete el.__reset_input_handler;
  }
})

router.beforeEach((to, form, next) => {
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// 注册过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

document.body.addEventListener('touchstart', function (){});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: vuex,
  components: { App },
  mixins: [http, passport, RongIMClientInit],
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js